import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule, Http } from '@angular/http';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ChartsModule } from 'ng2-charts/ng2-charts'; //FOR OPTIMIZATION
import { enableProdMode } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SessionDemoModule } from './session/session.module';
enableProdMode();

import 'hammerjs';
// import { AngularFireModule } from '@angular/fire';
// import { AngularFirestoreModule } from '@angular/fire/firestore';
// import { AngularFireStorageModule } from '@angular/fire/storage';
// import { AngularFireAuthModule } from '@angular/fire/auth';
// import { AngularFireDatabaseModule, AngularFireDatabase } from '@angular/fire/database'
// import * as firebase from 'firebase/app'
// import { environment } from '../environments/environment'
import 'firebase/analytics';

// import { //FOR OPTIMIZATION
//   MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatPaginatorModule,
//   MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatNativeDateModule,
//   MatDialogModule, MatGridListModule, MatIconModule, MatInputModule, NativeDateAdapter,
//   MatListModule, MatMenuModule, MatProgressBarModule,
//   MatRadioModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSortModule,
//   MatSlideToggleModule, MatSnackBarModule, MatTableModule, MatTabsModule, MatToolbarModule,
//   MatTooltipModule, MatFormFieldModule, MatExpansionModule, DateAdapter
// } from '@angular/material';

import {MatButtonModule, MatCheckboxModule,MatSlideToggleModule,
	MatDialogModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSelectModule, MatSidenavModule,
	MatSnackBarModule, MatTooltipModule, MatFormFieldModule,MatDatepickerModule,MatStepperModule,MatProgressSpinnerModule } from '@angular/material';

import { FlexLayoutModule } from '@angular/flex-layout';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
// import { AgmCoreModule } from '@agm/core';
import { TourNgBootstrapModule } from 'ngx-tour-ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate/ng2-translate';
import { SidebarModule } from 'ng-sidebar';
import { Ng5BreadcrumbModule, BreadcrumbService } from 'ng5-breadcrumb';
import { Ng2PageScrollModule} from 'ng2-page-scroll';
// import { ToastrModule } from 'ngx-toastr';
import { LoadingBarHttpModule } from '@ngx-loading-bar/http';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { SnackbarModule } from 'ngx-snackbar';
// import { LoadingBarModule } from 'ngx-loading-bar';
import { ChankyaAppComponent, SafePipe} from './app.component';
import { SharedDataService} from './shared-data.service';
import { IndexedDbStorageService } from './indexed-db-storage.service';
import { AuthenticationService } from './authentication.service';
import { AuthGuard } from './auth.guard';
import { PageTitleService } from './core/page-title/page-title.service';
import { AppRoutes } from './app-routing.module';
import { MainComponent } from './main/main.component';
import { AuthComponent } from './auth/auth.component';
import { MenuToggleModule } from './core/menu/menu-toggle.module';
import { MenuItems } from './core/menu/menu-items/menu-items';
import { InvoiceBillDetailsModalComponent } from './modals/invoice-bill-details-modal/invoice-bill-details-modal.component';
import { ExportDataModalComponent } from './modals/export-data-modal/export-data-modal.component';
import { DateTimeService } from './services/date-time/date-time.service';
// import { NgDragDropModule } from 'ng-drag-drop';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
// import { Observable } from "rxjs-compat/Observable";
import 'rxjs/add/observable/forkJoin';
// import { NgCircleProgressModule } from 'ng-circle-progress';
import { FileService } from './file.service';
import { LoadingModalComponent } from './modals/loading-modal/loading-modal.component';
import { RegisterComponent } from './session/register/register.component';
import { ComingSoonComponent } from './session/coming-soon/coming-soon.component';
import { LockScreenComponent } from './session/lockscreen/lockscreen.component';
import { SubscribesComponent } from './session/subscribes/subscribes.component';
import { UnderMaintanceComponent } from './session/under-maintance/under-maintance.component';
import { NotFoundComponent } from './session/not-found/not-found.component';
import { HorizontalLayoutComponent } from './horizontal-layout/horizontal-layout.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { GoogleApiService } from './google-api.service';
import { Common } from './common/common.module';
import { ImgPreviewerComponent } from './modals/img-previewer/img-previewer.component';
import { PrepaidServicesModule } from './modals/prepaid-services/prepaid-services.module';
import { PrepaidServicesService } from './prepaid-services.service';
// import { UserIdMappingPipe } from './user-id-mapping.pipe';

export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, 'assets/i18n', '.json');
}

const perfectScrollbarConfig: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

// firebase.initializeApp(environment.firebaseConfig);
// firebase.analytics.isSupported();

@NgModule({
	imports: [
		Ng2PageScrollModule,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		// AngularFirestoreModule, // firestore
		// AngularFireAuthModule, // auth
		// AngularFireStorageModule, // storage
		// AngularFireDatabaseModule,
		HttpClientModule,
		ReactiveFormsModule,
		// MatAutocompleteModule,
		MatButtonModule,
		// MatButtonToggleModule,
		// MatCardModule,
		MatCheckboxModule,
		// MatChipsModule,
		MatDatepickerModule,
		// MatNativeDateModule,
		MatDialogModule,
		// MatExpansionModule,
		MatFormFieldModule,
		// MatGridListModule,
		MatIconModule,
		MatInputModule,
		// MatListModule,
		// MatMenuModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		// MatRadioModule,
		MatSelectModule,
		MatSlideToggleModule,
		// MatSliderModule,
		MatSidenavModule,
		MatSnackBarModule,
		MatStepperModule,
		// MatTabsModule,
		// MatToolbarModule,
		MatTooltipModule,
		// MatPaginatorModule,
		// MatSortModule,
		// ChartsModule,
		LoadingBarHttpModule,
      	LoadingBarModule,
      	NgbModule.forRoot(),
		// MatTableModule,
		// MatPaginatorModule,
		SidebarModule.forRoot(),
		RouterModule.forRoot(AppRoutes, { useHash: true }),
		TourNgBootstrapModule.forRoot(),
		FlexLayoutModule,
		PrepaidServicesModule,
		// ToastrModule.forRoot(),
		SnackbarModule.forRoot(),
		NgbModalModule.forRoot(),
		Ng5BreadcrumbModule.forRoot(),
		// NgDragDropModule.forRoot(),
		// AgmCoreModule.forRoot({apiKey: 'AIzaSyBtdO5k6CRntAMJCF-H5uZjTCoSGX95cdk'}),
		PerfectScrollbarModule,
		MenuToggleModule,
		HttpModule,
		SessionDemoModule,
		OAuthModule.forRoot(),
		TranslateModule.forRoot({
			provide: TranslateLoader,
			useFactory: (createTranslateLoader),
			deps: [Http]
		}),
		// NgCircleProgressModule.forRoot({
		// 	radius: 100,
		// 	percent: 60,
		// 	outerStrokeWidth: 16,
		// 	innerStrokeWidth: 8,
		// 	outerStrokeColor: "#78C000",
		// 	innerStrokeColor: "#C7E596",
		// 	animationDuration: 300
		// }),
		Common
	],
	declarations: [
		ChankyaAppComponent,
		RegisterComponent,
		ComingSoonComponent,
		// UploadComponent,
		LockScreenComponent,
		SubscribesComponent,
		UnderMaintanceComponent,
		NotFoundComponent,
		HorizontalLayoutComponent,
		MainComponent,
		ExportDataModalComponent,
		InvoiceBillDetailsModalComponent,
		AuthComponent,
		SafePipe,
		LoadingModalComponent,
		ImgPreviewerComponent,
		// UserIdMappingPipe,
	],
	entryComponents: [
		InvoiceBillDetailsModalComponent,
		ExportDataModalComponent,
		LoadingModalComponent,
		ImgPreviewerComponent,

	],
	bootstrap: [ChankyaAppComponent],
	providers: [
		GoogleApiService,
		MenuItems,
		BreadcrumbService,
		PageTitleService,
		SharedDataService,
		PrepaidServicesService,
		IndexedDbStorageService,
		DateTimeService,
		AuthenticationService,
		AuthGuard,
		FileService,
		
	]
})

export class ChankyaAppModule {}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/app.module.ts